// ------------------------------------
// Tooltips
// ------------------------------------

// Instância
var tippyInstance;

if (typeof tippy === 'function') {
  // Configurações padrão
  tippy.setDefaultProps({
    allowHTML: true, // Habilita as tags HTML no conteúdo
    maxWidth: 250, // Largura máxima
    theme: 'lp-tippy', // Tema customizado
    animation: 'scale', // Tipo de animação
    dynamicTitle: true,
  });
  initTippy();
}

// Inicializa a instância do Tippy.js
function initTippy() {
  tippyInstance = tippy('[data-tippy-content]');
}
